<div>
    <svg-icon style="
    position: absolute;
    right: 5px;
" (click)="close(false)" [svgStyle]="{ 'width.px':35,'height.px':35 }" src="/assets/icons/close-modal-primary.svg"
        class="cursor-pointer"></svg-icon>
    <img src="{{data}}" class="image-dialog" />
</div>